export const documentKeys = {
   all: ['documents'] as const,
   byUser: (userId: string) => [...documentKeys.all, { userId, type: 'all' }] as const,
   byCourse: (userId: string, courseName: string) =>
      [...documentKeys.byUser(userId), { courseName, type: 'course' }] as const,
   byDocument: (userId: string, courseName: string, fileName: string) =>
      [...documentKeys.byCourse(userId, courseName), { fileName, type: 'document' }] as const,
   documentData: (courseName: string, fileName: string) => ['document-data', courseName, fileName] as const,
}
